/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Transaction type for VAT purposes (domestic, intra_eu_b2b, intra_eu_b2c, export). Always determined based on issuer/customer countries.
 * @nullable
 */
export type AdvanceInvoiceTransactionType = typeof AdvanceInvoiceTransactionType[keyof typeof AdvanceInvoiceTransactionType] | null;


export const AdvanceInvoiceTransactionType = {
  domestic: 'domestic',
  intra_eu_b2b: 'intra_eu_b2b',
  intra_eu_b2c: 'intra_eu_b2c',
  '3w_b2b': '3w_b2b',
  '3w_b2c': '3w_b2c',
  export: 'export',
} as const;
